module.exports = __webpack_public_path__ + "img/lookbook_4_right.4ce43982.png";